/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface ICreateAsynchronousPaymentErrorMessageProps {
    message?: string;
}

/**
 * CreateAsynchronousPaymentErrorMessage.
 * @param root0
 * @param root0.message
 * @extends {React.FC<ICreateAsynchronousPaymentErrorMessageProps>}
 */
const CreateAsynchronousPaymentErrorMessage: React.FC<ICreateAsynchronousPaymentErrorMessageProps> = ({ message }) => {
    if (!message) {
        return null;
    }

    return <p className='ms-create-asynchronous-payment__error-message'>{message}</p>;
};

export default CreateAsynchronousPaymentErrorMessage;
